import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { useHBPrimeData } from 'hb-redux-store/feature/halalboxPrime/hbPrime.hooks';

import Loader from 'components/mweb/Skeletons/Loader/Loader';
import MembershipPlan from 'components/mweb/HalalboxPrime/MembershipPlan';
import MembershipTermsAndCondition from 'components/mweb/HalalboxPrime/MembershipTermsAndCondition';
import {
  SELECT_PLAN_TEXT,
  TNC,
  TNC_DESCRIPTION,
} from 'hb-redux-store/constants/halalboxPrime/index';

import './halalbox-prime.scss';
import HalalboxPrimeImage from 'assets/halalbox-prime/desktop-hb-prime-landing.png';
import MembershipCTA from 'components/mweb/HalalboxPrime/MembershipCTA';

const HalalboxPrime = () => {
  const [selectedPlan, setSelectedPlan] = useState();
  const {
    hbPrimeStore: { loading, hbPrimeMembershipDetail },
  } = useHBPrimeData(true);
  const {
    membershipDescription = '',
    membershipPlans = [],
    tncTitle = '',
    tncDescription = [],
  } = hbPrimeMembershipDetail;

  useEffect(() => {
    if (membershipPlans && membershipPlans?.length) {
      membershipPlans.forEach(element => {
        if (element?.isSelected) setSelectedPlan(element);
      });
    }
  }, [membershipPlans]);

  return (
    <>
      {loading && <Loader />}
      <div className="desktop-hb-prime">
        <div className="desktop-hb-prime-img-wrapper">
          <div className="desktop-hb-prime-img-container">
            <img src={HalalboxPrimeImage} className="desktop-hb-prime-img" />
          </div>
          <div className="desktop-hb-prime-description">
            {membershipDescription}
          </div>
        </div>
        <div className="desktop-hb-prime-info-wrapper">
          {membershipPlans?.length && (
            <div className="desktop-hb-prime--membership-plan-wrapper">
              <span className="desktop-hb-prime-plan-heading-text">
                {SELECT_PLAN_TEXT}
              </span>
              <MembershipPlan
                data={membershipPlans}
                selectedPlan={selectedPlan}
                updateSelectedPlan={data => setSelectedPlan(data)}
              />
            </div>
          )}

          <MembershipCTA selectedPlan={selectedPlan} />

          {!!tncDescription?.length && (
            <div className="desktop-hb-prime--faq-container">
              <MembershipTermsAndCondition
                data={tncDescription}
                tncTitle={tncTitle}
              />
            </div>
          )}

          <div className="hb-prime--tnc-container">
            <span className="hb-prime--more-info-text">{TNC_DESCRIPTION}</span>
            <Link
              to="/help/tnc#hb-select"
              className="button action-link hb-prime--tnc-link"
            >
              {TNC}
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default HalalboxPrime;
